export const PHONE_NUMBER = '+448000590598';
export const PHONE_DISPLAY = '0800 059 0598';
export const EMAIL = 'info@screwfixcustom.com';
export const WHATSAPP_URL = 'https://wa.me/448000590598';
